import { Fragment, ReactElement } from 'react'

import { PublicNoticePDF } from './Pdffiles'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { BulletedList } from '@/components/layouts/Ir/BulletedList'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'

import { BulletinDigest, CompanyList, PublicNotice } from '@/types/publicNotice'

type Props = {
  bulletinDigest: BulletinDigest
  companyList: CompanyList[]
  bulletinList: { [key: string]: PublicNotice[] }
  finalAccountList: { [key: string]: PublicNotice[] }
}

export const PublicNoticePage = ({
  bulletinDigest,
  companyList,
  bulletinList,
  finalAccountList,
}: Props) => {
  return (
    <Layout>
      <SectionTitle
        titleText="Electronic Public Notice"
        subTitleText="電子公告"
        color="normal"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      {bulletinDigest.title && (
        <section>
          <Paragraph>{bulletinDigest.summary}</Paragraph>
          <Spacer h={{ sp: 10, pc: 15 }} />
          {bulletinDigest.listItems.length > 0 && (
            <BulletedList>
              {bulletinDigest.listItems
                .slice(1)
                .split('→')
                .map((value, index) => (
                  <li key={`${index}${value}`}>{value}</li>
                ))}
            </BulletedList>
          )}
          <Spacer h={{ sp: 70, pc: 100 }} />
        </section>
      )}
      {companyList.map((company) => (
        <Fragment key={`${company._id}`}>
          <PublicNoticePDF
            company={company}
            bulletin={bulletinList[company._id]}
            finalAccount={finalAccountList[company._id]}
          />
          <Spacer h={{ sp: 70, pc: 100 }} />
        </Fragment>
      ))}
    </Layout>
  )
}

PublicNoticePage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '電子公告', path: '' },
  ]

  return (
    <>
      <Head
        title="電子公告"
        description="トライアルホールディングスグループの公告について掲載しています。"
        ogp={{ url: 'ir/public-notice' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
